import { useState } from "react";

import { useAppSelector } from "@evr/hooks/reduxHooks";
import { selectCurrencies } from "@evr/store/slices/currencies";
import { SelectWithLabel, SelectWithLabelDataType } from "@evr/ui/SelectWithLabel";

interface CurrencySelectProps {
  currencyCode?: string;
  onCurrencyChange?: (currencyCode: string) => void;
}

const CurrencySelect = ({ currencyCode, onCurrencyChange }: CurrencySelectProps) => {
  const currencies = useAppSelector(selectCurrencies);

  const priorityCodes = ["GBP", "USD", "EUR"];

  let items: SelectWithLabelDataType[] = [];
  let initialSelectedCode = currencyCode;

  if (currencies.length === 0) {
    items = [
      {
        key: "-1",
        value: "-1",
        label: "Could not load currencies",
      },
    ];
    initialSelectedCode = "-1";
  } else {
    const sortedCurrencies = [
      ...currencies
        .filter(c => priorityCodes.includes(c.code))
        .sort((a, b) => priorityCodes.indexOf(a.code) - priorityCodes.indexOf(b.code)),

      ...currencies.filter(c => !priorityCodes.includes(c.code)).sort((a, b) => a.name.localeCompare(b.name)),
    ];

    items = sortedCurrencies.map(c => ({
      key: c.code,
      value: c.code,
      label: `${c.name} ${c.code} ${c.symbol}`,
    }));
  }

  const [selectedCode, setSelectedCode] = useState(initialSelectedCode);

  const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newCode = e.target.value;
    setSelectedCode(newCode);
    if (onCurrencyChange && newCode !== "-1") {
      onCurrencyChange(newCode);
    }
  };

  return <SelectWithLabel id="currency-select" items={items} value={selectedCode} onChange={onChange} />;
};

export default CurrencySelect;
